import * as React from 'react';

import { ModalWindow } from '@cian/ui-kit';

export interface IMobileViewProps extends React.PropsWithChildren {
  isOpen: boolean;
  onClose(): void;
}

export const MobileView: React.FC<IMobileViewProps> = ({ isOpen, onClose, children }) => {
  return <ModalWindow open={isOpen} onClose={onClose} title="Расскажите подробнее" content={children} />;
};

MobileView.displayName = 'MobileView';
